import { Check } from "lucide-react";

const PACKAGES = [
  {
    lookup_key: "mp_basic", testid: "basic", name: "Basic", price: "89€", period: "/ una tantum",
    pay_url: "https://buy.stripe.com/fZubIV6sf2DJ5qgair2Ry01",
    duration: "6 Settimane", durationColor: "#a020f0", tag: "Entry Level", featured: false,
    features: [
      "Scheda allenamento personalizzata",
      "Accesso completo app dedicata",
      "Video esecuzione di ogni esercizio",
      "Tracciamento carichi e progressioni",
      "Integratori consigliati mirati",
    ],
    cta: "Acquista Basic • 89€",
  },
  {
    lookup_key: "mp_premium", testid: "premium", name: "Premium", price: "149€", period: "/ 3 mesi",
    pay_url: "https://buy.stripe.com/00w4gt3g31zF05WfCL2Ry02",
    duration: "12 Settimane", durationColor: "#38bdf8", tag: "Completo", featured: true,
    features: [
      "Nuova scheda ogni 6 settimane",
      "Programma alimentare dedicato",
      "Accesso totale all'app & video",
      "Supporto chat continuo",
      "Piano integrazione avanzato",
    ],
    cta: "Acquista Premium • 149€",
  },
  {
    lookup_key: "mp_premium_extended", testid: "extended", name: "Premium Extended", price: "799€", period: "/ anno",
    pay_url: "https://buy.stripe.com/bJeaER03R2DJ05WeyH2Ry03",
    duration: "12 Mesi", durationColor: "#c084fc", tag: "Annuale VIP", featured: false,
    features: [
      "Protocollo annuale completo 12 mesi",
      "Scheda aggiornata ogni 6 settimane",
      "Piani alimentari adattivi periodici",
      "Supporto prioritario chat diretta",
      "Check video esecuzione tecnica",
    ],
    cta: "Acquista Extended • 799€",
  },
];

const PackageCard = ({ pkg }) => {
  const buy = () => {
    window.location.href = pkg.pay_url;
  };

  return (
    <div data-testid={`package-card-${pkg.testid}`}
      className={`relative flex flex-col justify-between p-8 rounded-2xl transition-[border-color,box-shadow] ${
        pkg.featured
          ? "bg-[#1b0d33] border-2 border-[#a020f0] shadow-2xl shadow-[#6a0dad]/40 lg:-translate-y-2"
          : "bg-[#120a21] border border-[#281647] hover:border-[#a020f0]/50"
      }`}>
      {pkg.featured && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-gradient-to-r from-[#6a0dad] to-[#a020f0] text-[10px] uppercase font-extrabold text-white tracking-wider shadow-md">
          Consigliato
        </div>
      )}
      <div>
        <div className="flex items-center justify-between mb-4">
          <span className="text-xs font-bold uppercase tracking-wider mono-font" style={{ color: pkg.durationColor }}>
            {pkg.duration}
          </span>
          <span className={`px-2.5 py-1 rounded text-[10px] uppercase font-bold ${pkg.featured ? "bg-[#6a0dad]/40 text-white" : "bg-[#23153d] text-[#cbd5e1]"}`}>
            {pkg.tag}
          </span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
        <div className="flex items-baseline gap-1 mb-6">
          <span className="text-4xl font-extrabold text-white">{pkg.price}</span>
          <span className={`text-xs ${pkg.featured ? "text-[#a78bfa]" : "text-[#64748b]"}`}>{pkg.period}</span>
        </div>
        <ul className={`space-y-3 text-xs mb-8 ${pkg.featured ? "text-[#e2e8f0]" : "text-[#cbd5e1]"}`}>
          {pkg.features.map((f) => (
            <li key={f} className="flex items-center gap-2">
              <Check className="w-3.5 h-3.5 shrink-0" style={{ color: pkg.featured ? "#38bdf8" : "#a020f0" }} />
              {f}
            </li>
          ))}
        </ul>
      </div>
      <button data-testid={`buy-${pkg.testid}-button`} onClick={buy}
        className={`w-full py-3.5 rounded-xl text-white font-bold text-xs uppercase tracking-wider transition-[filter,background-color] flex items-center justify-center gap-2 ${
          pkg.featured
            ? "bg-gradient-to-r from-[#6a0dad] to-[#a020f0] hover:brightness-110 shadow-lg shadow-[#6a0dad]/50"
            : "bg-[#1e1038] hover:bg-[#2e1954] border border-[#a020f0]/30"
        }`}>
        {pkg.cta}
      </button>
    </div>
  );
};

export const Pacchetti = () => (
  <section id="pacchetti" data-testid="pacchetti-section" className="py-24 px-6 bg-[#0a0414] border-t border-[#1e1038]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs uppercase tracking-widest text-[#a020f0] font-bold mono-font">Listino Ufficiale</span>
        <h2 className="display-font text-4xl md:text-6xl uppercase text-white mt-2">Scegli il Tuo Pacchetto</h2>
        <p className="text-sm text-[#94a3b8] mt-3">Pagamento sicuro Stripe con attivazione immediata via app.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
        {PACKAGES.map((p) => <PackageCard key={p.lookup_key} pkg={p} />)}
      </div>
      <p className="text-center text-xs text-[#64748b] mt-10">
        Prezzi IVA inclusa dove applicabile. Pagamento unico, nessun rinnovo automatico. Consulta i{" "}
        <a href="/termini-di-vendita" className="text-[#a78bfa] hover:text-white underline">Termini di Vendita</a> e il{" "}
        <a href="/diritto-di-recesso" className="text-[#a78bfa] hover:text-white underline">Diritto di Recesso</a>.
      </p>
    </div>
  </section>
);
